/**
 * Advisor app Firebase bootstrap — authenticates against the PRIMARY project.
 *
 * Uses the shared, empty-string-aware bootstrap (`@secure-vault/firebase-auth`)
 * so the config-coalesce / quote-stripping logic lives in exactly one place
 * (previously this app hand-rolled its own untyped `config.js`).
 *
 * Only Firebase **Auth** is used from the browser — Firestore/Storage/Functions
 * are accessed server-side through the Rust API — so only `auth` (and the app
 * handle) are exported.
 */
import {
  type FirebaseWebConfig,
  initFirebaseAuth,
} from "@secure-vault/firebase-auth";

const env = import.meta.env;

const config: FirebaseWebConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY ?? "",
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN ?? "",
  projectId: env.VITE_FIREBASE_PROJECT_ID ?? "",
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
};

const useEmulator = env.VITE_USE_EMULATOR === "true";

export const { app: firebaseApp, auth } = initFirebaseAuth({
  name: "app",
  config,
  useEmulator,
  emulatorHost: env.VITE_AUTH_EMULATOR_HOST || "127.0.0.1:9099",
});

if (useEmulator && typeof window !== "undefined") {
  // Playwright drives auth state through `window.auth`; module exports are not
  // reachable from page.evaluate.
  (window as unknown as { auth: typeof auth }).auth = auth;
}
